import React, { useState } from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, Loader2Icon, CheckCircleIcon } from 'lucide-react';
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
      // Reset success message after 5 seconds
      setTimeout(() => setIsSuccess(false), 5000);
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <section id="contact" className="py-24 relative z-10 border-t border-white/5" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-35">
            Ready to Scale?
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-36">
            Book a complimentary 30-minute strategy session with our senior
            advisors. Let's map out your financial trajectory.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-37">
          {/* Contact Info */}
          <div className="lg:col-span-1 space-y-8" data-id="element-38">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-sm" data-id="element-39">
              <h3 className="text-xl font-semibold text-white mb-6" data-id="element-40">
                Get in Touch
              </h3>

              <div className="space-y-6" data-id="element-41">
                <div className="flex items-start gap-4" data-id="element-42">
                  <div className="p-3 rounded-lg bg-blue-500/10 text-blue-400" data-id="element-43">
                    <PhoneIcon className="w-6 h-6" data-id="element-44" />
                  </div>
                  <div data-id="element-45">
                    <p className="text-sm text-slate-400 mb-1" data-id="element-46">Call Us</p>
                    <p className="text-white font-medium" data-id="element-47">1300 SCALE FIN</p>
                    <p className="text-white font-medium" data-id="element-48">(1300 722 533)</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-49">
                  <div className="p-3 rounded-lg bg-cyan-500/10 text-cyan-400" data-id="element-50">
                    <MailIcon className="w-6 h-6" data-id="element-51" />
                  </div>
                  <div data-id="element-52">
                    <p className="text-sm text-slate-400 mb-1" data-id="element-53">Email</p>
                    <p className="text-white font-medium" data-id="element-54">
                      strategy@scalefinance.com.au
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-55">
                  <div className="p-3 rounded-lg bg-teal-500/10 text-teal-400" data-id="element-56">
                    <MapPinIcon className="w-6 h-6" data-id="element-57" />
                  </div>
                  <div data-id="element-58">
                    <p className="text-sm text-slate-400 mb-1" data-id="element-59">
                      Office (By Appointment)
                    </p>
                    <p className="text-white font-medium" data-id="element-60">
                      Level 42, 100 Barangaroo Ave
                    </p>
                    <p className="text-white font-medium" data-id="element-61">
                      Sydney NSW 2000, Australia
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-white/10" data-id="element-62">
                <p className="text-sm text-slate-400 mb-2" data-id="element-63">Business Hours</p>
                <p className="text-white" data-id="element-64">
                  Monday - Friday: 8:30 AM - 5:30 PM AEST
                </p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-65">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-sm relative overflow-hidden" data-id="element-66">
              {isSuccess ? <div className="absolute inset-0 bg-[#0a0a1a]/95 backdrop-blur-md flex flex-col items-center justify-center z-10 animate-in fade-in duration-300" data-id="element-67">
                  <CheckCircleIcon className="w-16 h-16 text-green-400 mb-4" data-id="element-68" />
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-69">
                    Request Received
                  </h3>
                  <p className="text-slate-400 text-center max-w-md" data-id="element-70">
                    Thank you for reaching out. One of our senior strategists
                    will contact you within 24 hours to schedule your
                    consultation.
                  </p>
                </div> : null}

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-71">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-72">
                  <div data-id="element-73">
                    <label htmlFor="name" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-74">
                      Full Name *
                    </label>
                    <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full bg-[#0a0a1a] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" placeholder="John Doe" data-id="element-75" />
                  </div>
                  <div data-id="element-76">
                    <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-77">
                      Email Address *
                    </label>
                    <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full bg-[#0a0a1a] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" placeholder="john@example.com" data-id="element-78" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-79">
                  <div data-id="element-80">
                    <label htmlFor="phone" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-81">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full bg-[#0a0a1a] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" placeholder="0400 000 000" data-id="element-82" />
                  </div>
                  <div data-id="element-83">
                    <label htmlFor="service" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-84">
                      Primary Interest
                    </label>
                    <select id="service" name="service" value={formData.service} onChange={handleChange} className="w-full bg-[#0a0a1a] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all appearance-none" data-id="element-85">
                      <option value="" disabled data-id="element-86">
                        Select a service...
                      </option>
                      <option value="Financial Planning" data-id="element-87">
                        Financial Planning
                      </option>
                      <option value="Tax Strategy" data-id="element-88">Tax Strategy</option>
                      <option value="Wealth Management" data-id="element-89">
                        Wealth Management
                      </option>
                      <option value="Business Advisory" data-id="element-90">
                        Business Advisory
                      </option>
                      <option value="Retirement Planning" data-id="element-91">
                        Retirement Planning
                      </option>
                      <option value="Cash Flow Optimization" data-id="element-92">
                        Cash Flow Optimization
                      </option>
                      <option value="Other" data-id="element-93">Other</option>
                    </select>
                  </div>
                </div>

                <div data-id="element-94">
                  <label htmlFor="message" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-95">
                    How can we help you scale? *
                  </label>
                  <textarea id="message" name="message" required rows={4} value={formData.message} onChange={handleChange} className="w-full bg-[#0a0a1a] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all resize-none" placeholder="Tell us briefly about your current financial situation and goals..." data-id="element-96"></textarea>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full py-4 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-semibold text-lg hover:shadow-[0_0_20px_rgba(59,130,246,0.4)] transition-all disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-97">
                  {isSubmitting ? <>
                      <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-98" />
                      Processing...
                    </> : 'Request Consultation'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}